import { MAX_SPICES, Units } from "@/data/schema";
import { RESOURCES } from "@/data/resources";
import { isDefaultFilter } from "@/hooks/useFilter";


export type FilterSnapshot = {
  isFromSharedLink: boolean;
  isShaken: boolean;
  title: string;
  author: string;
  spices: Map<number, any>;
  unit: Units;
  quantity: number;
};

export type ValidationResult = | { success: true } | { success: false; error: string };

/** Pure validation function - returns complete execution state */
export function validate(filter: FilterSnapshot): ValidationResult {
  
  if (filter.isFromSharedLink) 
  {
    if (!filter.isShaken) return { success: false, error: "bad url, shaken missing" };
    if (!filter.title || !filter.author) return { success: false, error: "bad url, blend info missing" };
    if (!filter.spices || filter.spices.size === 0 || filter.spices.size >= MAX_SPICES)  return { success: false, error: "bad url, invalid spices" };
  }
  
  if (!filter.isFromSharedLink && !isDefaultFilter(filter)) // fails on isDefaultFilter
  {
    return { success: false, error: "not a shareable link"}
  }

  return { success: true };
}

export function getCriticalResources(filter: FilterSnapshot): string[] {
  const critical: string[] = [
    RESOURCES.environment.key,
    RESOURCES.bottleModel.key,
    RESOURCES.bottleNormal.key,
    RESOURCES.bottleRoughness.key,
  ];

  if (filter.isFromSharedLink) {
    critical.push(
      RESOURCES.nutrition.key,
      RESOURCES.spicesFallback.key,
      RESOURCES.spicesNormal.key,
      RESOURCES.spicesTexture.key,
      RESOURCES.label.key,
    );
  }

  return critical;
}
